import { Label } from "reactstrap";
import styled from "styled-components";
import MawbInput from "../../../components/custom/MawbInput";
import { useEffect, useState } from "react";
import { IFFM } from "../../../globals/interfaces";
import { notify, validateAwb } from "../../../utils";
import apiClient from "../../../apiClient";
import VirtualTable from "../../../components/custom/VirtualTable";
import Layout from "../../../components/custom/Layout";
import ModalManagePerStorage from "./ModalManagePerStorage";
import { useAppContext } from "../../../context";
import _ from "lodash";
import { Table } from "reactstrap";
import { FWB } from "../../../components/counter/import/interfaces";

export type HandleUpdate = (values: IFFM) => Promise<void>;

export default function PerStorageUpdate() {

    const { user } = useAppContext();
    const s_pou = user.s_unit.substring(1, 4);
    const [s_mawb, set_s_mawb] = useState('');
    const [data, setData] = useState<Array<IFFM>>([]);
    const [fwb, setFwb] = useState<FWB>();
    const [modal, setModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<IFFM>();

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await apiClient.get(`/per-storage-update?s_mawb=${s_mawb.replace(/-/g, '')}&s_pou=${s_pou}`);
                setData(res.data.ffms);
                setFwb(res.data.fwb);
            } catch (err) {
                alert(err);
            }
        }
        if (validateAwb(s_mawb)) {
            getData();
        } else {
            setData([]);
        }
    }, [s_mawb, s_pou]);

    const launchUpdate = (item: IFFM) => {
        setSelectedItem(item);
        setModal(true);
    }

    const handleUpdate: HandleUpdate = async (values: IFFM) => {
        if (!selectedItem) return;
        try {
            await apiClient.put(`/per-storage-update`, values);
            setData(prev => {
                const copy = _.cloneDeep(prev);
                const updateId = copy.findIndex(item => item.s_flight_id === selectedItem.s_flight_id);
                copy[updateId] = values;
                return copy;
            });
            setModal(false);
            notify('Updated');
        } catch (err) {
            alert(err);
        }
    }

    return (
        <Layout>
            <h1>Per Storage Update</h1>
            <FlexContainer>
                <Label>Type AWB</Label>
                <MawbInput
                    value={s_mawb}
                    onChange={mawb => set_s_mawb(mawb)}
                />
            </FlexContainer>
            <div>
                <h6>FWB Details</h6>
                {
                    fwb && (
                        <Table>
                            <tbody>
                                <tr>
                                    <td className={'bg-primary'} style={{ width: 300}}>Name and Quantity of Goods</td>
                                    <td>{fwb.s_goods_description}</td>
                                </tr>
                                <tr>
                                    <td className={'bg-primary'}>Special Handling Codes</td>
                                    <td>{fwb.s_special_handling_codes}</td>
                                </tr>
                                <tr>
                                    <td className={'bg-primary'}>Handling Information</td>
                                    <td>{fwb.s_other_service_information}</td>
                                </tr>
                            </tbody>
                        </Table>
                    )
                }
            </div>
            <VirtualTable
                data={data}
                mapping={[{
                    name: 'Flight',
                    value: 's_flight_id'
                }, {
                    name: 'SHC',
                    value: 's_special_handling_code'
                }, {
                    name: 'Arrival Date',
                    value: 'd_arrival_date',
                    date: true,
                    utc: true
                }, {
                    name: 'First Free',
                    value: 'd_storage_first_free',
                    date: true,
                    utc: true
                }, {
                    name: 'Second Free',
                    value: 'd_storage_second_free',
                    date: true,
                    utc: true
                }, {
                    name: 'Storage Start',
                    value: 'd_storage_start',
                    date: true,
                    utc: true
                }, {
                    name: 'Modified by',
                    value: 's_modified_by',
                    email: true
                }, {
                    name: 'Modified at',
                    value: 't_modified',
                    date: true,
                    utc: true
                }]}
                numRows={10}
                handleClick={launchUpdate}
            />
            <ModalManagePerStorage
                modal={modal}
                setModal={setModal}
                item={selectedItem}
                user={user}
                handleUpdate={handleUpdate}
            />
        </Layout>
    );
}

const Container = styled.div``;

const FlexContainer = styled.div`
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 10px;
`;